if (window.screen.width < 575) {      
  const buttonPage = document.querySelector('.product__cart-functions .add-to-cart');
  const buttonWrapperPage = document.querySelector('.product__cart-functions .flex-buttons');
  const buttonPageBlock = document.querySelector('.product__cart-functions');

  if(buttonPage && buttonPageBlock) {
    const offsetTop = buttonPageBlock.offsetTop + buttonPage.clientHeight + 120;

    document.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
  
      if (buttonWrapperPage.classList.contains('product__fixed_button')) {
        buttonWrapperPage.classList.remove('product__fixed_button');
      }
  
      if (scrollTop >= offsetTop) { 
        buttonWrapperPage.classList.add('product__fixed_button');
      }        
    });
  }  
}

// custom popup    
window.setTimeout(function() {    
  const mainContent = document.querySelector('.main-content');  
  const body = document.querySelector('body');  
  const html = document.querySelector('html');  
  const pageWrapper = document.querySelector('.page-wrapper');      
  const headerBlocks = document.querySelectorAll('.shopify-section-group-header-group');
  const stickyHeader = document.querySelector('.sticky-header'); 
  
  // vantages popup
  const vantagesItems = document.querySelectorAll('.card.card__popup');
  const vantagesItemPopups = document.querySelectorAll('.popup__vantages');

  showPopup(vantagesItems, vantagesItemPopups);

  // content popup
  const productContentItems = document.querySelectorAll('.toggle--popup .toggle__title');
  const productContentPopups = document.querySelectorAll('.popup__product_content');

  showPopup(productContentItems, productContentPopups);

  // delivery popup
  const productDeliveryItems = document.querySelectorAll('.delivery__btn');
  const productDeliveryPopups = document.querySelectorAll('.popup__delivery');

  showPopup(productDeliveryItems, productDeliveryPopups);

  // product related color popup
  const productRelatedColorItems = document.querySelectorAll('.related-color-list li.related__show_all');
  const productRelatedColorPopups = document.querySelectorAll('.popup__product_related_color');

  showPopup(productRelatedColorItems, productRelatedColorPopups);

  // popup configurator block
  const productConfiguratorBtn = document.querySelectorAll('.configurator__button_js');
  const productConfiguratorPopups = document.querySelectorAll('.popup__configurator_list');

  showPopup(productConfiguratorBtn, productConfiguratorPopups);
  
  function showPopup(buttons, popups) {      
    buttons.forEach(function(item) {
      
      item.addEventListener('click', function() {                
        mainContent.classList.add('content-index');          

        bodyLock();

        if (stickyHeader) {
          stickyHeader.classList.add('hidden')
        }
        
        popups.forEach(popupItem => {              
          const vantagesItemWrapperClose = popupItem.querySelector('.popup__custom .popup__wrapper');
          const vantagesItemClose = popupItem.querySelector('.popup__custom .cros');
          
          if (popupItem.dataset.id === item.id) {
            popupItem.classList.add('popup__active');

            closePopup(vantagesItemWrapperClose, popupItem);
            closePopup(vantagesItemClose, popupItem);
          }
        });
      })
      
    });
  }

  function closePopup(btn, popups) {
    btn.addEventListener('click', function() {
      mainContent.classList.remove('content-index');          

      if (stickyHeader) {
        stickyHeader.classList.remove('hidden')
      }
      
      if (popups.classList.contains('popup__active')) {
        popups.classList.remove('popup__active');
      }

      body.style.paddingRight = 0;
      body.classList.remove('body__lock');
    })
  }

  function bodyLock() {
    const lockPaddingValue = window.innerWidth - mainContent.offsetWidth + 'px';
    
    body.classList.add('body__lock');
    
    if (window.innerWidth > 1024) {
      body.style.paddingRight = lockPaddingValue;
    }
  }
}, 500);

window.setTimeout(function() {
  const reviews = document.querySelector('#judgeme_product_reviews');      
  const reviewsToggleContent = document.querySelector('.toggle.reviews .toggle__content');
  const reviewsLink = document.querySelector('.jdgm-prev-badge');
  const reviewsToggle = document.querySelector('.toggle.reviews');
  const toggleItems = document.querySelectorAll('.toggle.toggle--faq');

  if (reviews && reviewsToggleContent) {
    reviewsToggleContent.append(reviews);        
  }
  
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function() {
      if(reviewsToggle) {
        toggleItems.forEach(function(item) {
          const content = item.querySelector('.toggle__content');
          
          item.classList.remove('opened');
          content.style.display = 'none';
        })
        
        const reviewsContent = reviewsToggle.querySelector('.toggle__content');
        
        reviewsToggle.classList.add('opened');
        reviewsContent.style.display = 'flex';
      }
    });  
  }
}, 500); 

window.setTimeout(function() {
 const shopifyModels = document.querySelector('.shopify-model-viewer-ui');
 const popupModel = document.querySelector('.popup_model');
 const popupModelWindow = document.querySelector('.popup_model_window');
 const popupModelClose = document.querySelector('.popup_model_cros');            
 const btnShow = document.querySelector('.btn_theed_js');
 const body = document.querySelector('body');
 const headerBlocks = document.querySelectorAll('.shopify-section-group-header-group');
 const stickyHeader = document.querySelector('.sticky-header'); 
 
 if (btnShow) {
   btnShow.addEventListener('click', function() {
    popupModelWindow.append(shopifyModels);
    body.classList.add('body_overflow_hidden');
    popupModel.classList.add('popup_model_active');

    if (stickyHeader) {
      stickyHeader.classList.add('hidden')
    }

    headerBlocks.forEach((item) => {
      if (item) {
        item.classList.add('hidden')
      }
    })
  })
 }

 if (popupModelClose) {
    popupModelClose.addEventListener('click', function() {
      body.classList.remove('body_overflow_hidden');
      popupModel.classList.remove('popup_model_active');

      if (stickyHeader) {
        stickyHeader.classList.remove('hidden')
      }

      headerBlocks.forEach((item) => {
        if (item) {
          item.classList.remove('hidden')
        }
      })
    })
 }
}, 1000); 

// window.setTimeout(function() {
//  const treedMobile = document.querySelector('.btn_theed_mobile');

//  if (treedMobile) {
//    treedMobile.classList.add('btn_theed_small');
//  } 
// }, 2500);


// hide title color related block
let elementDrawer = document.querySelector('.hc-color-drawer-label');

if (elementDrawer && elementDrawer.classList.contains('hc-color-drawer-hide')) {
  let prevElementDrawer = elementDrawer.previousElementSibling;

  if (prevElementDrawer && prevElementDrawer.classList.contains('product-variant__name')) {    
    prevElementDrawer.style.display = 'none';
  }
}
// sale product persentage
const variants = document.querySelectorAll('.hc-popup-item');
const productSaleLabels = document.querySelectorAll('.product__sale');
const productPrice = document.querySelector('.product-price--original');
const formProductId = document.querySelector('.product-actions form input[name="id"]');

function showSaleLabel(variantId, variants) {
  productSaleLabels.forEach(function(label) {
    const idVariant = label.dataset.variantId;
    const selectedVariant = label.dataset.variantSelected;
    const priceVariant = label.dataset.price;
    const salePriceVariant = label.dataset.salePrice;
    const persentageBlockVariant = label.querySelector('.product__sale_persentage');
    const persentage = priceVariant / salePriceVariant * 100 - 100;
    const activeSaleLabelPopup = variants > 1 ? variantId : idVariant;    

    if (salePriceVariant && idVariant === activeSaleLabelPopup || formProductId.value === idVariant) {
      if (label.classList.contains('product__sale_hide')) {
        label.classList.remove('product__sale_hide');

        if (!productPrice.classList.contains('sale_price')) {
          productPrice.classList.add('sale_price');
        }
      }
    } else {
      label.classList.add('product__sale_hide');

      if (productPrice.classList.contains('sale_price')) {
        productPrice.classList.remove('sale_price');
      }
    }

    if (persentageBlockVariant) persentageBlockVariant.innerHTML = Math.round(persentage);
  })
} 

showSaleLabel('', variants.length);

// delivery variants block
const deliveryDecline = document.querySelectorAll('.delivery_decline');

function delivery(variantId) {
  deliveryDecline.forEach(function(item) {
    const itemVariantActive = item.dataset.variantActive;
    const itemVariantId = item.dataset.variantId;
    const itemActive = variantId ? variantId : itemVariantActive;

    if (itemActive == itemVariantId) {
      if (item.classList.contains('delivery_decline_hide')) {
        item.classList.remove('delivery_decline_hide');
      }
    } else {
      item.classList.add('delivery_decline_hide');
    }     
  })
};  

delivery();  

// sale and delivery variants block listener click
variants.forEach(function(variant) {
  variant.addEventListener('click', function() {
    setTimeout(function() {
      delivery(formProductId.value);
      showSaleLabel(formProductId.value, variants.length);
    }, 100);
  })
})

// tooltip
document.addEventListener('DOMContentLoaded', function() {
  const tooltipContainers = document.querySelectorAll('.tooltip');

  tooltipContainers.forEach(container => {
      const tooltipText = container.getAttribute('data-tooltip');

      const tooltipElement = document.createElement('span');
      tooltipElement.className = 'tooltip-text';
      tooltipElement.innerText = tooltipText;

      container.appendChild(tooltipElement);
  });
});

// qty list
let qtyBlock = document.querySelector('.product-quantity');
let summItem = 100;

if(qtyBlock) {
  let qtySelect = qtyBlock.querySelector('.qty');

  if (qtySelect) {
    for (let i = 6; i <= summItem; i++) {
      const listSelect = document.createElement('option');
      listSelect.textContent = `${i}`;
      listSelect.value = `${i}`;
      qtySelect.appendChild(listSelect);
    }
  }
}

// show popup
const popups_app = document.querySelectorAll('.popup__app_model');

if (popups_app) {
  popups_app.forEach(function(item) {
    const intervalId = setInterval(function() {
      item.style.opacity = 1;    
      clearInterval(intervalId);
    }, 1000)     
  }) 
}

// configurator gallery
const productTemplate = document.querySelector('.tda-app-section-model-viewer');
const productGaleryConfigurator = document.querySelector('.product__galery');
let htmlDocument = document.documentElement;
let langSite = htmlDocument.getAttribute('lang');
let configuratorBtnText = 'View real product photos'

if (langSite == 'it') {
  configuratorBtnText = 'Guarda le foto reali del prodotto';
}

if (productGaleryConfigurator && productTemplate) {  
  const GaleryConfiguratorItems = productGaleryConfigurator.querySelectorAll('.card')[0];
  const GaleryConfiguratorImg = GaleryConfiguratorItems.querySelector('.card__image img');

  console.log(GaleryConfiguratorImg.getAttribute('src'));

  if (productGaleryConfigurator) {
    let scrollGallery = document.createElement('a');

    scrollGallery.classList.add('scroll_gallery', 'anchor', 'tooltip');
    scrollGallery.href = '#product-gallery';
    scrollGallery.dataset.tooltip = configuratorBtnText;

    productTemplate.appendChild(scrollGallery);
    
    let galleryImage = document.createElement('img');

    galleryImage.classList.add('scroll_gallery_image', 'anchor');
    galleryImage.src = GaleryConfiguratorImg.getAttribute('src');  
    galleryImage.alt = GaleryConfiguratorImg.getAttribute('alt');

    scrollGallery.appendChild(galleryImage);    
  }
}

document.addEventListener("DOMContentLoaded", function() {
  if (productGaleryConfigurator) {
    const gridContainer = productGaleryConfigurator.querySelector('.grid');
    const images = gridContainer.querySelectorAll('.card');
  
    if (images.length === 3) {
        gridContainer.classList.add('grid-three');
    }
  }  
});


// anchor scrool
const anchorLinks = document.querySelectorAll('a.anchor');

anchorLinks.forEach(link => {
  if (link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const stickyHeader = document.querySelector('.sticky-header');
      const breadcrumbsNav = document.querySelector('.product__breadcrumbs_nav');
      let topOffset = 20;
      if (stickyHeader && stickyHeader.classList.contains('show')) {
        topOffset += stickyHeader.offsetHeight;
      }
      if (breadcrumbsNav) {
        topOffset += breadcrumbsNav.offsetHeight;
      }

      const href = this.getAttribute('href').substring(1);
      const scrollTarget = document.getElementById(href);
      const elementPosition = scrollTarget.getBoundingClientRect().top;
      const offsetPosition = elementPosition - topOffset;

      window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth',
      })
    })
  }
})

// configurator reviews
const configuratorReviews = document.querySelector('.configurator_reviews');
const timeReviewsBlock = document.querySelector('.delivery__time_reviews')

if (configuratorReviews) {
  configuratorReviews.parentElement.classList.add('configurator_reviews_section');
  timeReviewsBlock.appendChild(configuratorReviews);
}
// promotion banner copy code (start)
(function() {
  const copyButtons = document.querySelectorAll('.promotion__banner_copy');
  if (!copyButtons) return;
  
  copyButtons.forEach((copybutton) => {
    copybutton.addEventListener('click', function() {
      const code = this.dataset.code;
      const originalText = this.textContent;
      
      navigator.clipboard.writeText(code).then(() => {
        this.textContent = this.dataset.text;
        setTimeout(() => this.textContent = originalText, 2000);
      });
    });
  })  
})();
// promotion banner copy code (end)

// configurator shipping (start)
// configurator shipping (start)
window.addEventListener("Angle3DCustomizerLoaded", function() {
  const optionValuesEl = document.getElementById('product-option-values');
  if (!optionValuesEl) return;
  const optionValuesData = JSON.parse(optionValuesEl.textContent);
  const configurator_options = document.querySelectorAll('.tda-customizer-customization-option-value');
  const handle = window.location.pathname.split('/products/')[1].split('?')[0];

  changeOptions();

  configurator_options.forEach((item) => {
    item.addEventListener('click', function() {
      setTimeout(changeOptions, 100);
    })
  })  

  async function changeOptions() {
    const deliveryTimeEl = document.querySelector('.delivery__time');
    const variantNameEl = document.querySelector('.tda-customizer-variant-name');
    const configurator_shipping = document.querySelector('.product__shipping');
    if (!deliveryTimeEl || !variantNameEl || !configurator_shipping) return;
    const configurator_shipping_type = deliveryTimeEl.dataset.type;
    const configurator_delivery_time = deliveryTimeEl.dataset.deliveryType;
    const configurator_option_name = variantNameEl.textContent;
    const configurator_shipping_data = configurator_shipping.dataset;
    const configurator_shipping_text = configurator_shipping.querySelector('.product__shipping_text');
    const configurator_shipping_time = configurator_shipping.querySelector('.product__shipping_time');    

    const parts = configurator_option_name.split(' / ');
    const optionValueIds = parts.map((part, index) => optionValuesData[index]?.values[part]).filter(Boolean);

    if (optionValueIds.length !== parts.length) {
      configurator_shipping_text.textContent = configurator_shipping_data[renderText(configurator_delivery_time, 'text')];
      configurator_shipping_time.textContent = configurator_shipping_data[configurator_delivery_time];
      return;
    }

    const res = await fetch(`/products/${handle}?sections=configurator-info&option_values=${optionValueIds.join(',')}`);
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['configurator-info'], 'text/html');

    console.log(configurator_shipping_type);
    

    if (configurator_shipping_type == 'tags') {
      const shippingType = doc.getElementById('configurator-shipping-data')?.dataset.shippingType;      

      if (shippingType) {
        configurator_shipping_text.textContent = configurator_shipping_data[renderText(shippingType, 'text')];
        configurator_shipping_time.textContent = configurator_shipping_data[shippingType];
      } else {
        configurator_shipping_text.textContent = configurator_shipping_data[renderText(configurator_delivery_time, 'text')];
        configurator_shipping_time.textContent = configurator_shipping_data[configurator_delivery_time];
      }
    } else if (configurator_shipping_type == 'my_app') {
      const shippingText = doc.getElementById('configurator-shipping-data')?.dataset.shippingText;
      const shippingTime = doc.getElementById('configurator-shipping-data')?.dataset.shippingTime;     

      if (shippingText && shippingTime) {
        configurator_shipping_text.textContent = shippingText;
        configurator_shipping_time.textContent = shippingTime;
      }
    }   

    function renderText(status, key) {
      return key + status.charAt(0).toUpperCase() + status.slice(1);
    }
  }
});
// configurator shipping (end)

// transfer title configurator
const confTitle = document.querySelector('.tda-customizer-product-title');
const confOptionContainer = document.querySelector('.tda-customizer-controls-container');

if (window.screen.width < 767 && confTitle && confOptionContainer) {
  confOptionContainer.appendChild(confTitle);  
}

// customize configurator
const configurator = document.querySelector('.tda-customizer-wrapper');

// hide h1
if (configurator) {
  const headH1 = configurator.querySelector('h1').parentElement;

  headH1.style.display = 'none';
}

const configuratorAdaptiveMobile = document.querySelector('.configurator__adaptive');

if (configuratorAdaptiveMobile) {
  // remove swipper slider
  const cleanSwiperSliders = () => {
    document.querySelectorAll('.swiper-wrapper').forEach(wrapper => {
      const parent = wrapper.parentElement;
      const slides = wrapper.querySelectorAll('.swiper-slide');

      slides.forEach(slide => {
        slide.removeAttribute('style');
        slide.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next');
        parent.appendChild(slide);
      });

      wrapper.remove();

      if (parent.classList.contains('swiper-container')) {
        parent.classList.remove('swiper-container', 'swiper-container-initialized', 'swiper-container-horizontal');
        parent.removeAttribute('style');
      }

      parent.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach(nav => nav.remove());
    });
  };

  cleanSwiperSliders();

  const observer = new MutationObserver(() => cleanSwiperSliders());
  observer.observe(document.body, { childList: true, subtree: true });

  // add title blocks
  if (window.innerWidth < 767) {
    const waitForBlocks = setInterval(() => {
      const all = [...document.querySelectorAll('[id^="tda-customizer-customization-option-"]')];
    
      const topLevel = all.filter(el => {
        return !all.some(other => other !== el && other.contains(el));
      });
    
      const labels = [...document.querySelectorAll('div > strong')].map(el => el.textContent.trim()).filter(Boolean);
    
      if (topLevel.length > 0) {
        clearInterval(waitForBlocks);    
    
        topLevel.forEach(function(item, index) {
          let titleBlock = document.createElement('div');

          if (labels[index].toLowerCase().includes('color') || labels[index].toLowerCase().includes('seats') || labels[index].toLowerCase().includes('frames') || labels[index].toLowerCase().includes('fabric') || labels[index].toLowerCase().includes('wood')  || labels[index].toLowerCase().includes('sedile') || labels[index].toLowerCase().includes('telaio')  || labels[index].toLowerCase().includes('tessuto')  || labels[index].toLowerCase().includes('legno')) {
            item.classList.add('option__item', 'option__item_color');
          } else {
            item.classList.add('option__item');
          }

          titleBlock.classList.add('option__item_title');
    
          if (labels[index] == 'Size (Oak/Walhut)' || labels[index] == 'SIZE (OLIVE)') {
            titleBlock.textContent = "Size";
          } else {
            titleBlock.textContent = labels[index];
          }

          const itemSlides = item.querySelectorAll('.option-value-swiper-slide');

          itemSlides.forEach((slide) => {
            const slideOption = slide.querySelector('.tda-customizer-customization-option-value');

            changeClassActive();

            slide.addEventListener('click', () => {
              changeClassActive();
            })            
              
            function changeClassActive() {
              if (slideOption && slideOption.classList.contains('tda-customizer-customization-option-value-selected')) {            
                slide.classList.add('tda-customizer-customization-option-value-selected')
              }
            }
          })

          item.prepend(titleBlock);      
        })
      }
    }, 500);
  }
}

// price reviews main product (start)
if (window.innerWidth <= 767) {
  const productReviewsInterval = setInterval(() => {
    const productReviews = document.querySelector('.loox-rating');
    const productPriceReviews = document.querySelector('.price__block_reviews');

    if (productReviews) {
      productPriceReviews.appendChild(productReviews);    
      clearInterval(productReviewsInterval);
    }
  }, 300);
}

// price reviews main product (end)